export type SidebarState = 'collapse' | 'compact' | 'default';
